import React, { useState } from 'react'
import useWindowDimensions from 'Shared/utils/useWindowDimensions'
import { t } from 'ttag'

import PuxIcon from '../PuxIcon/PuxIcon'
import PuxButton from '../PuxButton/PuxButton'

interface ContactButtonProps {
  forceButton?: boolean
}

const ContactButton = ({ forceButton = false }: ContactButtonProps) => {
  const { width } = useWindowDimensions()
  const baseUrl = t`Redmine.Header.ContactSales.Link`
  const text = t`Redmine.Header.ContactSales`
  const [url, setUrl] = useState(baseUrl)

  function setUrlUTM() {
    if (typeof window !== `undefined`) {
      const urlUTM = window.location.pathname.startsWith(`/`)
        ? window.location.pathname.replace(/\//g, `_`).replace(`_`, ``)
        : window.location.pathname.replace(/\//g, `_`)

      if (window?.location?.pathname === `/`) {
        setUrl(`${baseUrl}?u_source=website&u_medium=page&u_campaign=homepage`)
      } else {
        setUrl(`${baseUrl}?u_source=website&u_medium=page&u_campaign=${urlUTM}`)
      }
    }
  }

  if (forceButton || width >= 1400) {
    return (
      <div
        onMouseEnter={setUrlUTM}
        onMouseLeave={setUrlUTM}
        onClick={setUrlUTM}
        onMouseDown={setUrlUTM}
        onTouchStart={setUrlUTM}
      >
        <PuxButton
          buttonType='ghost'
          buttonSize='medium'
          buttonLink={{
            url: [url],
            internal: [true],
            text: [text],
          }}
        />
      </div>
    )
  } else {
    return (
      <div
        onMouseEnter={setUrlUTM}
        onMouseLeave={setUrlUTM}
        onClick={setUrlUTM}
        onMouseDown={setUrlUTM}
        onTouchStart={setUrlUTM}
      >
        <a href={url} className='Header-sales' aria-label={text}>
          <PuxIcon name='user-interface/email' size={12} decorative />
        </a>
      </div>
    )
  }
}

export default ContactButton
